@if (reportType !== null && reportId !== null) {
  <div style="margin-top: 5em;">
    <div class="pBI-button">
      <ion-button color="secondary" type="button" (click)="goBack()">{{ 'Return' | translate }}</ion-button>
      <ion-button color="secondary" type="button" (click)="pbiService.reload();">{{ 'Reload' | translate }}</ion-button>
      @if (report?.RLS ?? false) {
        <ion-button color="secondary" type="button" (click)="presentSetRLSPopover()">{{ 'Set RLS Filter' | translate }}</ion-button>
      }
      @if (!onmobileView && reportType.localeCompare('report', undefined, { sensitivity: 'accent'}) === 0) {
        <ion-button color="secondary"  (click)="presentChooseSizePopover();">{{ 'Choose Size' | translate }}</ion-button>
      }
      @if (!onmobileView) {
        <ion-button color="secondary" type="button" (click)="pbiService.showFullscreen()">{{ 'Fullscreen' | translate }}</ion-button>
      }
    </div>
    @if (showLoaderContainer) {
      <div id="pbi-loader-container">
        <pbi-loader id="pbi-loader"></pbi-loader>
        <div id="pbi-loader-text-1" class="pbi-loader-text">{{embedding ? ('Retrieving report' | translate) : loading ? ('Loading the data' | translate) : ('Rendering your visuals' | translate)}}...</div>
        <div id="pbi-loader-text-2" class="pbi-loader-text" style="visibility: hidden;">{{('Rendering your visuals' | translate)}}...</div>
      </div>
    }
    <div>
      <div [hidden]='!embeddingReport' class="embedding-powerBI" style="width: 100%;" id="reportContainer"></div>
      <div [hidden]='embeddingReport' class="embedding-powerBI" style="width: 100%;" id="dashboardContainer"></div>
    </div>
  </div>
}

